export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export const isSentryEnabled = Boolean(
  process.env.REACT_APP_MONITORING_ENABLED === 'true' && SENTRY_DSN
);
